
import { memo, type ReactNode } from 'react';
import { ReactFlowProvider } from '@xyflow/react';
import '@xyflow/react/dist/style.css';

interface FlowProviderProps {
    children: ReactNode;
}

/**
 * Wrapper component that provides ReactFlow context.
 * Use this to wrap your flow components.
 */
export const FlowProvider = memo(function FlowProvider({ children }: FlowProviderProps) {
    return <ReactFlowProvider>{children}</ReactFlowProvider>;
});

